import React from 'react'
import './BuyBanner.css'

const getBadgeImageUrl = badgeName =>
  `https://cdn.artifactuprising.com/assets/images/PDP+Icons/${badgeName}.png?auto=webp&width=200`

const BuyBanner = () => {
  return (
    <div className="buy-banner">
      <h2>Because Your Story Matters</h2>

      <div className="buy-banner-wrapper">
        <div className="buy-badge-pair">
          <div className="buy-badge-wrapper">
            <img
              className="buy-badge"
              src={getBadgeImageUrl('crafted-for-forever')}
              alt="Crafted for forever"
            />
            <div className="badge-title">
              Premium Quality <br /> Products
            </div>
            <div className="desktop-only">__</div>
            <div className="badge-copy desktop-only">
              Carefully crafted with time-tested materials that let your most
              meaningful stories live on.
            </div>
          </div>
          <div className="buy-badge-wrapper">
            <img
              className="buy-badge"
              src={getBadgeImageUrl('thoughtfully-sourced')}
              alt="Thoughtfully sourced"
            />
            <div className="badge-title">
              Thoughtfully <br /> sourced materials
            </div>
            <div className="desktop-only">__</div>
            <div className="badge-copy desktop-only">
              Because the moments that are worth preserving happen in places
              that are worth protecting.
            </div>
          </div>
        </div>
        <div className="buy-badge-pair">
          <div className="buy-badge-wrapper">
            <img className="buy-badge" src={getBadgeImageUrl('made-to-love')} alt="Made with love" />
            <div className="badge-title">
              Made to Love, <br /> Guaranteed
            </div>
            <div className="desktop-only">__</div>
            <div className="badge-copy desktop-only">
              If you’re not completely happy with your order experience, we’ll
              make it right — human to human.
            </div>
          </div>
          <div className="buy-badge-wrapper">
            <img
              className="buy-badge"
              src={getBadgeImageUrl('assembled-usa')}
              alt="Assembled in the usa"
            />
            <div className="badge-title">
              Assembled <br /> in the USA
            </div>
            <div className="desktop-only">__</div>
            <div className="badge-copy desktop-only">
              We maintain a deep connection with the artifacts we create by
              crafting them close to home.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BuyBanner



// WEBPACK FOOTER //
// ./src/components/BuyBanner/index.js